// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"cda612ba","814":"8ec992fe","859":"905d08bb"}[chunkId] + ".chunk.js";
};